import { render, staticRenderFns } from "./ImageText.vue?vue&type=template&id=46bb3f04&scoped=true"
import script from "./ImageText.vue?vue&type=script&lang=js"
export * from "./ImageText.vue?vue&type=script&lang=js"
import style0 from "./ImageText.vue?vue&type=style&index=0&id=46bb3f04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.38_css-loader@6.11.0_webpack@5.94.0__handlebar_2aedba235eac052937d84807a282dc7b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bb3f04",
  null
  
)

export default component.exports